import logo from './Vectorlim_eye.svg';
import lim_footer from './Footer.svg';
import './App.sass';
import React, { useState, useEffect, Component } from 'react';
import vorple from "vorple";
import "vorple/lib/css/vorple.css";
import 'antd/dist/antd.css';
import { Card, Avatar } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';

const { Meta } = Card;
//import Account from "./Account";

/* TODO:
1. fix favicon
2. write a story
3. Store it on the server
4. Get Web3 Button working
5. Have Vorple extension call Web3 for account signing at the beginning of
reading session
    Will need to present a dismissable notice if web3 log-in doesn't go through
    Meaning we'll:
      Ask for web3
      User submits
      Check to confirm it went through
        If not, ask again
        If user dismisses, raise dismissable banner
6. At a specific point, save the state by signing an on-chain transaction
7. When calling "Save", Call a transaction request saving the "save" to 
the NFT

*/

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        emailValue: '',
        fNameValue: '',
        lNameValue: '',
        containerRef: '',
        
    };
  }

// FIR VORPLE, CHANGE TO CLASS Reference to the element we use as the interpreter container
//const containerRef = useRef(null);
/*useEffect() {
    if( containerRef ) {
        vorple.options = {
            // URL to the game file
            story: "./public/blog2.gblorb",

            // Container for the interpreter
            container: containerRef.current
        };
        vorple.init()
    }
}, [ containerRef ]);*/

 /*class App extends React.Component {
  constructor(props) {
    super(props) {
      super(props);
      this.state = {
        count: 0
      };
    }
  }

  componentDidMount() {
    const { count } = this.state;
    document.title = `You've clicked ${count} times.`;
  }

  componentDidUpdate() {
    const { count } = this.state;
    document.title = `You've clicked ${count} times.`;
  }}
   render() {
    const { count } = this.state;
    return (
      <div className="App">
        <header className="App-header" font-size="100px" > LIMINAL
          <img src={logo} className="App-logo" alt="logo" />
          <p font-size="50px">
            A protocol for permissionless
            <a 
              className="if-link"
              href="ifdb.tads.org" 
              target="_blank" 
            > interactive fiction
              </a>. 
              <br></br>
            An exploration into collaborative 
            <a 
              className="hypertext-link"
              href="ifdb.tads.org"
              target="_blank"
              rel="noopener noreferrer"
            > hypertext
            </a>. <br></br>
            An extension of
            <a 
              className="cryptomedia-link"
              href = 'https://cryptomedia.wtf/'
              target="_blank"
              rel="noopener noreferrer"
            > Cryptomedia</a>.
          </p>

          <form action="https://cool.us16.list-manage.com/subscribe/post" method="POST" noValidate>
                  <input type="hidden" name="u" value="eb05e4f830c2a04be30171b01"/>
                <input type="hidden" name="id" value="8281a64779"/>
                <label htmlFor='MERGE0'>
                    Email
                    <input 
                        type="email" 
                        name="EMAIL" 
                        id="MERGE0"
                        value={this.state.emailValue} 
                        onChange={ (e)=>{this.setState({emailValue: e.target.value});} } 
                        autoCapitalize="off" 
                        autoCorrect="off"
                     /> 
                </label>
                <label htmlFor='MERGE1'>
                    First name
                    <input 
                        type="text" 
                        name="FNAME" 
                        id="MERGE1" 
                        value={this.state.fNameValue} 
                        onChange={(e)=>{this.setState({fNameValue: e.target.value});}}
                    />
                </label>
                <label htmlFor='MERGE2'>
                    Last name
                    <input 
                        type="text" 
                        name="LNAME" 
                        id="MERGE2" 
                        value={this.state.lNameValue} 
                        onChange={(e)=>{this.setState({lNameValue: e.target.value});}}
                    />
                </label>
                  <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button"/>

                <div style={{position: 'absolute', left: '-5000px'}} aria-hidden='true' aria-label="Please leave the following three fields empty">
                    <label htmlFor="b_name">Name: </label>
                    <input type="text" name="b_name" tabIndex="-1" value="" placeholder="Freddie" id="b_name"/>

                    <label htmlFor="b_email">Email: </label>
                    <input type="email" name="b_email" tabIndex="-1" value="" placeholder="youremail@gmail.com" id="b_email"/>

                    <label htmlFor="b_comment">Comment: </label>
                    <textarea name="b_comment" tabIndex="-1" placeholder="Please comment" id="b_comment"></textarea>
                </div>
              </form>
        </header>
      </div>

      
      
      <div>
        <p>You've clicked {count} times.</p>
        <button onClick={() => this.setState({ count: count + 1 })}>
          Click me
        </button>
      </div>
    );
  } }*/

  render() {
    return (
      
      <div>
            <br></br>
            <br></br>
            <img src={logo} className="App-logo2" alt="limina eye logo" />  
            
            {/*<Card
              style={{ width: 400 }}
              cover={
                <img
                  alt="example"
                  src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
                />
              }
              actions={[
                <SettingOutlined key="setting" />,
                <EditOutlined key="edit" />,
                <EllipsisOutlined key="ellipsis" />,
              ]}
            >
              <Meta
                avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                title="Card title"
                description="This is the description"
              />
            </Card> */}
            <div>
              <div className="landing-text">
                <div>
                  <br></br>
                  <br></br>
                  <p font-size="50px">
                    A protocol for permissionless    
                    <a 
                      className="if-link"
                      href='https://ifdb.tads.org' 
                      target="_blank" 
                    > interactive fiction
                      </a>. 
                      <br></br>
                    An exploration into collaborative
                    <a 
                      className="hypertext-link"
                      href="https://www.w3.org/WhatIs.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    > hypertext
                    </a>. <br></br>
                    An extension of
                    <a 
                      className="cryptomedia-link"
                      href = 'https://cryptomedia.wtf/'
                      target="_blank"
                      rel="noopener noreferrer"
                    > Cryptomedia</a>.
                    <br></br>
                    Join the <a
                      className="lim-discord"
                      href = 'https://discord.gg/CxY9usvf4x'
                      target="_blank"
                      rel="noopener noreferrer"
                    >Discord</a>.
                    <br></br>
                    Learn more 
                    <a 
                      className="cryptomedia-link"
                      href = 'https://www.notion.so/Introducing-Liminal-17c49bb961454ac889bfecf4649a5886'
                      target="_blank"
                      rel="noopener noreferrer"
                    > here</a>.
                  </p>
                </div>
              </div>
            </div>
            <div class="glitch-wrapper">
              <div class="glitch" data-text="JOIN LIMINA"> JOIN LIMINA</div>
            </div>
              <br></br>
              <br></br>
            <form className="sub-form" action="https://protonmail.us1.list-manage.com/subscribe/post" method="POST" noValidate>
                      <input type="hidden" name="u" value="897ea4f41458011138b338b15"/>
                    <input type="hidden" name="id" value="683889618a"/>
                    <label class="sub-text" htmlFor='MERGE0'>
                        <input 
                            className="sub-input"
                            type="email" 
                            name="EMAIL" 
                            id="MERGE0"
                            value={this.state.emailValue} 
                            onChange={ (e)=>{this.setState({emailValue: e.target.value});} } 
                            autoCapitalize="off" 
                            autoCorrect="off"
                        /> 
                    </label>
                    <br/>
                    <br/>
                      <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="sub-button"/>

                    <div style={{position: 'absolute', left: '-5000px'}} aria-hidden='true' aria-label="Please leave the following three fields empty">
                        <label htmlFor="b_name">Name: </label>
                        <input type="text" name="b_name" tabIndex="-1" value="" placeholder="Freddie" id="b_name"/>

                        <label htmlFor="b_email">Email: </label>
                        <input type="email" name="b_email" tabIndex="-1" value="" placeholder="youremail@gmail.com" id="b_email"/>

                        <label htmlFor="b_comment">Comment: </label>
                        <textarea name="b_comment" tabIndex="-1" placeholder="Please comment" id="b_comment"></textarea>
                    </div>
                  </form>
                  <div>
                    {/* <footer>
                      <br></br>
                        <img src={lim_footer} className="footer" alt="footer" />  
                    </footer> */}
                  </div>
          
        </div> 
    );
    }
}


/*return (
    <div ref={containerRef} />
);*/
export default App;



// WEBPACK FOOTER //
// ./src/App.js